import * as React from 'react';
import * as moment from 'moment';

// types
import { IEndOperationDispatchProps, IEndOperationStoreProps } from 'modules/end-operation/end-operation.types';

// component
import EndOperationContent from './end-operation-content';

export class EndOperation extends React.PureComponent<IEndOperationProps> {
    private readonly isValid: boolean;

    constructor(props: IEndOperationProps) {
        super(props);

        this.isValid = this.isOperationValid();
    }

    public componentDidMount() {
        this.props.emitOperationEndingStatus(this.isValid);
    }

    /**
     * Dates received from server do not contain timezone information and should be considered as UTC.
     * Dates received from admin tool (beta flow only) have information about timezone, so moment.utc(...) will still work
     */
    public isOperationValid(): boolean {
        const { endDate: endDateISOString } = this.props;
        const expirationTime: moment.Moment = moment.utc(endDateISOString);

        if (!endDateISOString || !expirationTime.isValid()) {
            return true;
        }

        const localTime: moment.Moment = moment();
        return localTime.isBefore(expirationTime);
    }

    public render(): JSX.Element | null {
        const { children } = this.props;
        if (this.isValid) {
            return null;
        }

        return children ? <>{children}</> : <EndOperationContent />;
    }
}

export type IEndOperationProps = IEndOperationDispatchProps & IEndOperationStoreProps;

export default EndOperation;
